import { useMemo } from "react";

import type { AssetSource, AudioAsset } from "../assetTypes.ts";
import { extractAudioProperties } from "../metadataExtractors/index.ts";
import { useGetCachedAssetBlob } from "../query/index.ts";

export const useConstructAudioAsset = () => {
  const getCachedAssetBlob = useGetCachedAssetBlob();

  return useMemo(
    () =>
      async (source: AssetSource): Promise<AudioAsset | undefined> => {
        const tryGetAudioProperties = async () => {
          if ("assetId" in source) {
            const assetBlob = await getCachedAssetBlob(source.assetId);
            if (!assetBlob) {
              return undefined;
            }

            const objUrl = URL.createObjectURL(assetBlob);
            try {
              return { ...(await extractAudioProperties(objUrl)), contentType: assetBlob.type };
            } finally {
              URL.revokeObjectURL(objUrl);
            }
          } else if (source.url) {
            return await extractAudioProperties(source.url);
          }
        };

        const properties = await tryGetAudioProperties();

        return {
          source,
          ...properties,
        };
      },
    [getCachedAssetBlob],
  );
};
